import { useFilterDisabledSettings } from "@api";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { useMemo } from "react";
import { useModalOfferContext } from "../context";

export const ContractInput = () => {
  const { settings } = useGlobalContext();
  const { offer, setOffer, disabled, errors, setErrors, applyFollowUp, apply } = useModalOfferContext();

  const settingsContractTypes = useFilterDisabledSettings(
    settings?.settingsContractTypes,
    offer.contractType ? offer.contractType[0] : undefined
  );

  const value = useMemo(() => {
    const contractTypes = offer.contractType ? offer.contractType : null;
    if (contractTypes === null) {
      return null;
    }
    return settingsContractTypes.find((ct) => ct.value === contractTypes[0]) ?? null;
  }, [offer.contractType, settingsContractTypes]);

  return (
    <Autocomplete
      id="offer-contract-type-select"
      value={value}
      onChange={(_, contract) => {
        if (!contract) {
          setOffer((offer) => ({
            ...offer,
            contractDuration: undefined,
          }));
        }
        setOffer((offer) => ({
          ...offer,
          contractType: contract?.value ? [contract.value] : undefined,
          contractDuration: contract?.value === "cdi" ? undefined : offer.contractDuration,
        }));
        setErrors((errors) => ({ ...errors, contractType: false }));
      }}
      options={settingsContractTypes}
      disabled={disabled}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      getOptionLabel={(o) => o.label}
      renderInput={(props) => (
        <TextField
          {...props}
          label={
            <Box
              sx={{
                pr: 0.6,
              }}
            >
              Type de contrat*
            </Box>
          }
          size="small"
          fullWidth
          error={!!errors.contractType}
        />
      )}
    />
  );
};
